package ar.corzo.health_tracker.utils

actual fun log(message: Any?) {
    console.log(message)
}